"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringMap = isStringMap;
exports.selectAuthData = selectAuthData;
exports.selectAuthUid = selectAuthUid;
exports.selectAuthJwt = selectAuthJwt;
exports.selectCommunityProfile = selectCommunityProfile;
exports.selectProfilePicturesData = selectProfilePicturesData;
exports.selectProfilePictureForUid = selectProfilePictureForUid;
exports.selectUserProfilesDataMap = selectUserProfilesDataMap;
exports.selectUserData = selectUserData;
exports.selectUserLanguage = selectUserLanguage;
var immutable_1 = require("immutable");
var EMPTY_MAP = (0, immutable_1.Map)();
/**
 * Single point where we promise the runtime that an Immutable Map has
 * string keys. Immutable's own `Map.isMap` only narrows to
 * `Map<unknown, unknown>`, so every consumer funnels through this
 * predicate to keep the inevitable cast in one place.
 */
function isStringMap(value) {
    return immutable_1.Map.isMap(value);
}
// ── Auth ─────────────────────────────────────────────────────────────
function selectAuthData(state) {
    return isStringMap(state.auth) ? state.auth : undefined;
}
function selectAuthUid(state) {
    if (!isStringMap(state.auth))
        return undefined;
    var uid = state.auth.get('uid');
    if (typeof uid === 'string')
        return uid;
    if (typeof uid === 'number')
        return String(uid);
    return undefined;
}
function selectAuthJwt(state) {
    if (!isStringMap(state.auth))
        return '';
    var jwt = state.auth.get('jwt');
    return typeof jwt === 'string' ? jwt : '';
}
// ── Community profile slice ──────────────────────────────────────────
function selectCommunityProfile(state) {
    return isStringMap(state.communityProfile) ? state.communityProfile : undefined;
}
function selectProfilePicturesData(state) {
    if (!isStringMap(state.communityProfile))
        return EMPTY_MAP;
    var data = state.communityProfile.getIn(['profilePictures', 'data']);
    return isStringMap(data) ? data : EMPTY_MAP;
}
function selectProfilePictureForUid(state, uid) {
    if (!isStringMap(state.communityProfile))
        return undefined;
    var value = state.communityProfile.getIn(['profilePictures', 'data', uid]);
    return isStringMap(value) ? value : undefined;
}
// ── User profiles (multi-profile list) slice ────────────────────────
function selectUserProfilesDataMap(state) {
    if (!isStringMap(state.userProfiles))
        return undefined;
    var data = state.userProfiles.get('data');
    return isStringMap(data) ? data : undefined;
}
// ── User slice ──────────────────────────────────────────────────────
function selectUserData(state) {
    return isStringMap(state.user) ? state.user : undefined;
}
function selectUserLanguage(state) {
    if (!isStringMap(state.user))
        return undefined;
    var value = state.user.getIn(['data', 'language']);
    if (typeof value === 'string')
        return value;
    // List.isList only narrows to List<unknown>; the schema guarantees strings.
    if (immutable_1.List.isList(value))
        return value;
    return undefined;
}
